import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-benefits-hero',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './benefits-hero.component.html',
  styleUrls: ['./benefits-hero.component.scss']
})
export class BenefitsHeroComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('benefitsHero', { static: false }) benefitsHero?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.benefitsHero?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.benefitsHero.nativeElement,
        'Benefits Hero',
        'benefits-hero-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
